import { render, staticRenderFns } from "./MatchTeams.vue?vue&type=template&id=576713f6&scoped=true"
import script from "./MatchTeams.vue?vue&type=script&lang=js"
export * from "./MatchTeams.vue?vue&type=script&lang=js"
import style0 from "./MatchTeams.vue?vue&type=style&index=0&id=576713f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576713f6",
  null
  
)

export default component.exports